import registrationModule from './registration.module'
export default registrationModule.name
